import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderLastFlightOut from "../../../../src/content/last-flight-out/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderLastFlightOut,
  React
};